import { render, staticRenderFns } from "./Predictive-Maintenance.vue?vue&type=template&id=f27b8e80&scoped=true"
import script from "./Predictive-Maintenance.vue?vue&type=script&lang=js"
export * from "./Predictive-Maintenance.vue?vue&type=script&lang=js"
import style0 from "./Predictive-Maintenance.vue?vue&type=style&index=0&id=f27b8e80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27b8e80",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GlobalDataTable: require('/home/vsts/work/1/s/components/global/DataTable.vue').default})
